import Facebook from '../assets/icons/Facebook';
import Globe from '../assets/icons/Globe';
import Instagram from '../assets/icons/Instagram';
import LinkedIn from '../assets/icons/LinkedIn';
import Note from '../assets/icons/Note';
import RedNote from '../assets/icons/RedNote';
import X from '../assets/icons/X';
import YouTube from '../assets/icons/YouTube';

const snsIcons = {
  globe: Globe,
  linkedin: LinkedIn,
  facebook: Facebook,
  instagram: Instagram,
  x: X,
  rednote: RedNote, // Xiaohongshu
  youtube: YouTube,
  note: Note, // Japanese note.com
} as const;

export type SnsIconKey = keyof typeof snsIcons;
export type SnsIconValue = (typeof snsIcons)[SnsIconKey];

/**
 * Get the SNS icon by key.
 * Falls back to Globe if not found.
 */
const getSnsIcon = (icon: SnsIconKey) => {
  return snsIcons[icon] || Globe;
};

export default getSnsIcon;
